import React from "react";
import appConfig from "../../../config/app.config";


const staticAssetsUrl = appConfig.staticAssetsUrl;

const ContentSignIn = () => {
    return (
        <div>
            <h2 className="text-xl font-bold">2.Sign In Page</h2>
            <p>Enter the credentials (Username & Password) and <span className="font-bold">Sign In</span></p>
            <img className="pic" src={staticAssetsUrl + "user_manual/Sign_in.png"} />
        </div>
    )
}

export default ContentSignIn;